import React, { Suspense, lazy } from 'react';
import { useRoutes } from 'react-router-dom';
import { DefaultLayout } from '@shared/layouts';
import PrivateRoute from '@shared/layouts/PrivateRoute';
import MemberLayout from '@shared/layouts/MemberLayout';
import OtherLayout from '@shared/layouts/OtherLayout';
import Homepage from '@pages/home';
import RouteFallback from '@components/common/route-fallback';

// Route-level code splitting: every page below ships as its own chunk so the
// first paint only downloads the shell + the landing page.
const InfoUser = lazy(() => import('@pages/info-use'));
const Levelpage = lazy(() => import('@pages/level'));
const Detailpage = lazy(() => import('@pages/detail'));
const Otherpage = lazy(() => import('@pages/other'));
const Memberpage = lazy(() => import('@pages/member'));
const DepositConfirmPage = lazy(() => import('@pages/member/deposit/confirm'));
const WithDraw = lazy(() => import('@pages/member/withdraw'));
const InfoBankComponent = lazy(() => import('@components/infoBank'));
const HistoryDeposit = lazy(() => import('@pages/member/history-deposit'));
const Profile = lazy(() => import('@pages/member/profile'));
const InvitePage = lazy(() => import('@pages/member/invite'));
const ChangePass = lazy(() => import('@pages/member/change-pass'));
const HistoryWithdraw = lazy(() => import('@pages/member/history-withdraw'));
const Point = lazy(() => import('@pages/member/point'));
const HistoryPoint = lazy(() => import('@pages/member/history-point'));
const HistoryInvite = lazy(() => import('@pages/member/history-invite'));
const Register = lazy(() => import('@pages/register'));
const ForgotPass = lazy(() => import('@pages/forgot-password'));
const PageNew = lazy(() => import('@pages/news'));
const GameDetail = lazy(() => import('@pages/game-detail'));
const PostPage = lazy(() => import('@pages/post'));
const GameUser = lazy(() => import('@pages/GameUser'));
const NotFound = lazy(() => import('@pages/notfound'));
const ListPostPage = lazy(() => import('@pages/list-post'));
const ContactPage = lazy(() => import('@pages/contact'));

const AuthRoutes: React.FC = () => {
  const elements = useRoutes([
    {
      element: <DefaultLayout />,
      children: [
        {
          path: '/',
          element: <Homepage />,
        },

        {
          path: 'thong-tin',
          element: <InfoUser />,
        },
        {
          path: 'cap-bac',
          element: <Levelpage />,
        },
        {
          path: 'lien-he',
          element: <ContactPage />,
        },
        {
          path: 'dang-ky',
          element: <Register />,
        },
        {
          path: 'tro-choi/:id',
          element: <GameDetail />,
        },
        {
          path: 'quen-mat-khau',
          element: <ForgotPass />,
        },
        {
          path: 'tin-tuc',
          element: <PageNew />,
        },
        {
          path: 'tin-tuc/:id',
          element: <ListPostPage />,
        },
        {
          path: 'bai-viet/:id',
          element: <PostPage />,
        },
        {
          path: 'notfound',
          element: <NotFound />,
        },
        {
          path: '/:id',
          element: <Detailpage />,
        },
      ],
    },

    {
      element: <OtherLayout title="Khác" />,
      children: [
        {
          path: '/khac',
          element: <Otherpage />,
        },
      ],
    },
    {
      element: (
        <PrivateRoute
          element={MemberLayout}
          meta={{
            requiresAuth: true,
          }}
        />
      ),
      path: 'thanh-vien',
      children: [
        {
          path: 'nap-tien/xac-nhan',
          element: <DepositConfirmPage />,
        },
        {
          path: 'nap-tien',
          element: <Memberpage />,
        },
        {
          path: 'rut-tien',
          element: <WithDraw />,
        },
        {
          path: 'thong-tin-ngan-hang',
          element: <InfoBankComponent />,
        },
        {
          path: 'lich-su-nap-tien',
          element: <HistoryDeposit />,
        },
        {
          path: 'ho-so',
          element: <Profile />,
        },
        {
          path: 'gioi-thieu',
          element: <InvitePage />,
        },
        {
          path: 'doi-mat-khau',
          element: <ChangePass />,
        },
        {
          path: 'lich-su-rut-tien',
          element: <HistoryWithdraw />,
        },
        {
          path: 'chuyen-diem',
          element: <Point />,
        },
        {
          path: 'lich-su-chuyen-diem',
          element: <HistoryPoint />,
        },
        {
          path: 'lich-su-gioi-thieu',
          element: <HistoryInvite />,
        },
        {
          path: 'tro-choi',
          element: <GameUser />,
        },
      ],
    },
  ]);

  return <Suspense fallback={<RouteFallback />}>{elements}</Suspense>;
};

export default AuthRoutes;
